import * as React from "react";
import { useLocation } from "react-router-dom";
import _ from 'lodash';

import { CTableRow, CTableDataCell, CCol, CRow } from "@coreui/react";
import { DeleteIcon, EditIcon } from "../../../assets/images";
import Access from '../../../components/Access';
import { AccessType } from '../../../constants/roleAccessConstant';
import { ActionType, IColumnObject } from "./ITable";
import { itemColumns } from "../../../constants/newsConstant";

interface ITableItemProps {
  dataItem: IColumnObject[],
  actionsCallback?: (action: ActionType, data: any) => void;
}

const TableItem = ({
  dataItem,
  actionsCallback,
}: ITableItemProps) => {
  const { pathname: routePath } = useLocation();
  const actionsKey = itemColumns.actions.dbField; // 'actions'
  const filteredDataItem = !_.isEmpty(dataItem) && _.isArray(dataItem) && _.filter([...dataItem], function (o) { return !o.isHidden });
  const hasActions = !_.isEmpty(dataItem) && _.isArray(dataItem) && _.some([...dataItem], function (o) { return o.dbField === actionsKey });
  const actions = hasActions && dataItem.find((item) => item.dbField === actionsKey)?.value;

  const renderButton = (action: ActionType) => {
    let content = <></>;
    switch (action) {
      case ActionType.EDIT:
        content = (<Access route={routePath} access={[AccessType.UPDATE]}>
          <EditIcon
            height={40}
            width={40}
            onClick={() => {
              actionsCallback && actionsCallback(ActionType.EDIT_OPEN, dataItem);
            }}
          />
        </Access>
        );
        break;
      case ActionType.DELETE:
        content = (
          <Access route={routePath} access={[AccessType.DELETE]}>
            <DeleteIcon
              height={40}
              width={40}
              onClick={() => {
                actionsCallback && actionsCallback(ActionType.DELETE_OPEN, dataItem);
              }}
            />
          </Access>
        );
        break;
      // Add other cases as needed
      default:
        break;
    }
    return content;
  };

  const displayContent = (value: string, needBreakSpace: boolean) => {
    return (
      <div style={{ whiteSpace: needBreakSpace ? "break-spaces" : "nowrap" }}>
        {value}
      </div>
    );
  }

  return (
    <CTableRow>
      {filteredDataItem &&
        filteredDataItem.map((colValues, index) => (
          <CTableDataCell key={`TableItemCell${index}`}>
            {index === filteredDataItem.length - 1 ? (
              <CRow>
                <CCol>
                  {displayContent(colValues?.value, colValues?.needBreakSpace)}
                </CCol>
                {actions
                  && actions.length > 0
                  &&
                  <CCol sm="auto" className="d-flex pe-0">
                    {actions.map((action, index) => (
                      <div key={`TableItemAction${index}`} className={"clickable-icon pe-1"}>
                        {renderButton(action)}
                      </div>
                    ))}
                  </CCol>
                }
              </CRow>
            ) : (
              displayContent(colValues?.value, colValues?.needBreakSpace)
            )}
          </CTableDataCell>
        ))}
    </CTableRow>
  );
};

export default TableItem;
